<template>
    <div class="padding-20 margin-top-20 background-white ">
        <div class="index-div-content1">
            <h3 class="margin-bottom-20 center font-28 " style="color: #1B1B1B">
                <img src="../../assets/img/1.png" alt="" width="31"> <span style="margin:0 20px">应用案例</span> <img
                    src="../../assets/img/2.png" alt="" width="31">
            </h3>
            <div id="swiperBox1">
                <div class="swiper-wrapper new-el-menu-demo">
                    <div class="swiper-slide" v-for="(item,index) in info" :key="index">
                        <el-row type="flex" class="example-flex" >
                            <!--                            -->
                            <el-col  :xs="24" :sm="12"  class="index-inyong"
                                    :style="`background-image: url(${item.imgUrl})`">

                            </el-col>
                            <el-col :xs="24" :sm="12" class="el-col-content">
                                <div class="example-content" >
                                    <a href="/#/product/robot/cicadama#maodian"><p
                                            style="margin-bottom: 30px;color:#333333" class="font-24">{{item.title}}</p>
                                    </a>
                                    <p style="margin-bottom: 30px;line-height: 30px">
                                        {{item.content}}
                                    </p>
                                    <el-button  class="button shinydarken" @click="lookVideo(item)" style="width: 90px;">
                                        详情
                                    </el-button>
                                </div>


                            </el-col>
                        </el-row>
                    </div>
                    <!--          <div class="swiper-slide el-menu-item" v-for="item in 12">{{item}}</div>-->
                </div>
                <!-- 如果需要导航按钮 -->
                <div class="swiper-button-prev"><</div>
                <div class="swiper-button-next">></div>
            </div>
        </div>
        <el-dialog
                :title="itemTitle"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                :show-close="false"
                @close="handleClose"
                :width="dialogWidth">
            <video-component ref="videocomponet" :video-url="videoUrl"/>
            <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import VideoComponent from "./VideoComponent";
    import Swiper from 'swiper';

    export default {
        name: "example",
        props: ['info'],
        components: {VideoComponent},
        data() {
            return {
                videoUrl: '',
                dialogVisible: false,
                itemTitle:'',
                dialogWidth:0
            }
        },
        created() {
            this.setDialogWidth()
        },
        mounted() {
            window.onresize = () => {
                return (() => {
                    this.setDialogWidth()
                })()
            }
            this.$nextTick(() => {
                new Swiper('#swiperBox1', {
                    notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                    direction: "horizontal", //水平方向移动
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
                    autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
                    slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
                    resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
                    observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
                })
            })
        },
        methods: {
            setDialogWidth() {
                console.log(document.body.clientWidth)
                var val = document.body.clientWidth
                const def = 800 // 默认宽度
                if (val < def) {
                    this.dialogWidth = '100%'
                } else {
                    this.dialogWidth = def + 'px'
                }
            },
            handleClose(){
                console.log(123)
                this.videoUrl = ""
                this.$refs.videocomponet.pause()
            },
            lookVideo(obj) {
                this.videoUrl = obj.url
                this.itemTitle = obj.title
                this.dialogVisible = true

            }
        }
    }
</script>

<style scoped lang="scss">
    #swiperBox1 {
        position: relative;
        width: 100%;
        overflow: hidden;

        .swiper-button-prev, .swiper-button-next {
            bottom: 0px;
            top: auto;
            width: 32px;
            height: 32px;
            background: #005DAB;
            line-height: 32px;
            text-align: center;
            color: white;
        }

        .swiper-button-prev {
            left: calc(50% - 32px);
        }

        .swiper-button-next {
            left: calc(50% + 1px);
        }
    }
</style>